import { loyaltyApiSlice, magentoApiSlice, profileApiSlice } from "../slices";
export const apiMiddlewares = [loyaltyApiSlice.middleware, magentoApiSlice.middleware, profileApiSlice.middleware];
//# sourceMappingURL=apiMiddlewares.js.map